import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

//исходная функция на беке получает person = await models.Persons.findById(ctx.__.lot.persons[0]._id);
//пока делаем без фото, используя только
export async function makePDF(/*person*/data) {
    
    return new Promise(async (resolve, reject) => {
        /*const lot = this;
        let photo = await models.Files.findById(person.photos[0]._id);
        let photoSoc = person.socialPhotos[0] && person.socialPhotos[0]._id? await models.Files.findById(person.socialPhotos[0]._id) : undefined;
        let file = uploadDir + photo.location*/

        //let photoFile = fs.readFileSync(file).toString();

        //const contents = fs.readFileSync(file, { encoding: 'base64' }).toString(); true
        /*if (photoSoc) {
            let fileSoc = uploadDir + photoSoc.location
            var contentsSoc = fs.readFileSync(fileSoc, { encoding: 'base64' }).toString(); true
        }*/
        //var h2p = require('html2plaintext')

        let docInfo = {

            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [50, 50, 30, 60],

            styles:
            {
                header:
                {
                    fontSize: 18,
                    bold: true,
                    alignment: 'left',
                    color: 'black',
                },
                text:
                {
                    fontSize: 14,
                    bold: false,
                    alignment: 'left',
                    color: '#000000',
                },
            },
            content: [
                {
                    image: data.photo ? await getBase64ImageFromURL(`${process.env.REACT_APP_HOST}files/${data.photo}/image/`) : await getBase64ImageFromURL('/assets/img/person-default-icon.png'),
                    width: 150,

                },
                /*{
                    text: 'Фото для соц. сетей',
                    style: 'header',
                    margin: [0, 20, 0, 20]
                },
                photoSoc? {
                    image: 'data:' + photoSoc.mime + ';base64,' + contentsSoc,
                    width: 300,
                } : undefined,*/
                {
                    text: 'Фамилия',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.surname,
                    style: 'text',
                },
                {
                    text: 'Имя',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.name,
                    style: 'text',
                },
                {
                    text: 'Отчество',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.middlename,
                    style: 'text',
                },
                {
                    text: 'Телефон',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.phone,
                    style: 'text',
                },
                {
                    text: 'Email',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.email,
                    style: 'text',
                },
                {
                    text: 'Паспорт (серия)',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.passportseries,
                    style: 'text',
                },
                {
                    text: 'Паспорт (номер)',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.passportnumber,
                    style: 'text',
                },
                {
                    text: 'Кем выдан',
                    style: 'header',
                    margin: [0, 20, 0, 0]
                },
                {
                    text: data.passport_organization,
                    style: 'text',
                },
            ]
        }
        var doc = pdfMake.createPdf(docInfo);
        doc.download('persondata.pdf')
        /*await doc.getBuffer((pdfBuffer) => {
            //let fileName = uploadDir + 'asasdas1.pdf'
            //fs.createWriteStream(fileName).write(pdfBuffer);
            let buffer = Buffer.from(pdfBuffer, 'base64')
            resolve(buffer)
        })*/

        //return doc;
     })
}

function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}


// WEBPACK FOOTER //
// ./src/helpers/getPDF.js